import React, { useState } from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { IconButton, Container, Grid, Hidden } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SimplePopover from "../SimplePopover";
import { checkAdminUser } from "../../utils/objectManipulations.js";
import { useStyles } from "./styles";

const UserCard = ({ user, activateUser, clearNewUser }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activated, setActivated] = useState(user.active);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    clearNewUser();
  };

  const handleActivate = () => {
    setAnchorEl(null);
    //activation Item Action
    activateUser({ toggle: !activated, userId: user.id });
    setActivated(!activated);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-manager-card-more-vertical-button-popover-actions" : undefined;




  return (
    <Container maxWidth="xl">
      <Card className={classes.root}>
        <Grid container alignItems="center" className={classes.container}>
          <Grid item md={11} >
            <CardContent className={classes.body}>
              <Grid item md={4} className={classes.main}>
                <CardContent className={classes.content1}>
                  <Typography variant="h5" paragraph={true}>
                    {user.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {checkAdminUser(user)}
                  </Typography>
                </CardContent>
                <Hidden smUp>
                  <CardActions className={classes.popover}>
                    <IconButton
                      aria-label="more"
                      color="primary"
                      data-cy="more-btn-2"
                      id="more-btn-2"
                      onClick={handleClick}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </CardActions>
                </Hidden>
              </Grid>
              <Grid item md={8}>
                <CardContent className={classes.content2}>
                  <Grid item md={6}>
                    <Typography
                      variant="body2"
                      component="p"
                      className={classes.text}
                    >
                      {user.id}
                    </Typography>
                  </Grid>
                  <Grid item md={6}>
                    <Typography
                      variant="body2"
                      component="p"
                      className={classes.text}
                    >
                      {user.login}
                    </Typography>
                  </Grid>
                  <Grid item md={6}>
                    <Typography
                      variant="body2"
                      component="p"
                      className={classes.text}
                    >
                      {activated ? "active" : "inactive"}
                    </Typography>
                  </Grid>
                </CardContent>
              </Grid>
            </CardContent>
          </Grid>
          <Hidden smDown>
            <Grid item md={1}>
              <CardActions className={classes.popover}>
                <IconButton
                  data-cy="user-manager-card-more-vertical-button"
                  id="user-manager-card-more-vertical-button"
                  aria-label="more"
                  color="primary"
                  onClick={handleClick}
                >
                  <MoreVertIcon />
                </IconButton>
              </CardActions>
            </Grid>
          </Hidden>
        </Grid>
        <SimplePopover
          id={id}
          data-cy="user-manager-card-more-vertical-button-popover-actions"
          open={open}
          user={user}
          anchorEl={anchorEl}
          handleClose={handleClose}
          handleActivate={handleActivate}
          active={activated}
          route={`/gerenciar-usuarios/editar-usuario/${user.id}`}
        />
      </Card>
    </Container>
  );
};

const mapState = () => ({});

const mapDispatch = (dispatch) => ({
  activateUser: (payload) => dispatch.users.activateUserAsync(payload),
  clearNewUser: () => dispatch.users.clearNewUserAsync(),

});

export default connect(mapState, mapDispatch)(UserCard);
